import { Helmet } from 'react-helmet-async';

import SetupBillingView from 'src/sections/setup/setup-billing-view';

// ----------------------------------------------------------------------

// This page is used to prompt the user to choose a billing plan during the setup process.
// It is typically displayed after the user has completed the initial setup steps and is ready to configure

// http://localhost:3000/onboarding/organisation/billing/choose-plan
export default function SetupBillingPage() {
  return (
    <>
      <Helmet>
        <title>JT: Choose Your Plan</title>
      </Helmet>

      <SetupBillingView />
    </>
  );
}